export default "skymp5-front/a35670b280796add3e7423908eabe96f.png";